// extracted by mini-css-extract-plugin
export default {"root":"ProListingUserInfo_root__9QgQt"};